// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1yVdJ","ranges":"BmiRanges_ranges__2GAsZ"};